/**
 * Determines if a button is a Contact Support button based on its text content.
 * Used to standardize Contact Support button styling across all modals.
 *
 * @param text - The button text to check
 * @returns true if the text contains both "contact" and "support" (case-insensitive)
 *
 * @example
 * isContactSupportButton('Contact Support') // true
 * isContactSupportButton('Contact Cash App Support') // true
 * isContactSupportButton('contact support') // true
 * isContactSupportButton('Continue') // false
 */
export function isContactSupportButton(text?: string): boolean {
  if (!text) return false
  const lowerText = text.toLowerCase()
  return lowerText.includes('contact') && lowerText.includes('support')
}
